/* ASIO: when a product card swatch is hovered/tapped, swap the card's price and
   sale badge to that swatch's variant so they match the image shown.
   Loaded from snippets/product-block.liquid; guard ensures it only runs once. */
(function () {
  if (window.asioCardSwatchPrice) return;
  window.asioCardSwatchPrice = true;

  function apply(item) {
    var block = item.closest('product-block');
    if (!block) return;
    var key = item.getAttribute('data-option-item');
    if (block.dataset.asioSwatch === key) return;

    var priceTpl = item.querySelector('template.js-asio-swatch-price');
    var labelTpl = item.querySelector('template.js-asio-swatch-label');
    if (!priceTpl && !labelTpl) return;
    block.dataset.asioSwatch = key;

    if (priceTpl) {
      var priceCont = block.querySelector('.product-price--block');
      if (priceCont) priceCont.innerHTML = priceTpl.innerHTML;
    }

    if (labelTpl) {
      var wrap = block.querySelector('.image-label-wrap');
      if (wrap) {
        var old = wrap.querySelector(':scope > .product-label-container');
        if (old) old.remove();
        var html = labelTpl.innerHTML.trim();
        if (html) wrap.insertAdjacentHTML('beforeend', html);
      }
    }
  }

  function handler(evt) {
    var item = evt.target && evt.target.closest ? evt.target.closest('.product-block-options__item') : null;
    if (item) apply(item);
  }

  document.addEventListener('mouseover', handler);
  document.addEventListener('click', handler);
})();
